module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"どのサイズが合うかお悩みですか？{link}AIおすすめのサイズを確認してみてください！","label_link":"ここをクリックして"}}')
  delete Component.options._Ctor
}
